(function () {
    'use strict';

    angular
        .module('franchisee', [
            'franchisee.constants',
            'franchisee.components',
            'franchisee.directives',
            'franchisee.filters',
            'franchisee.interceptors',
            'franchisee.routes',
            'franchisee.services'
        ])
        .run(run);

    /** @ngInject */
    function run() {

    }
})();